<div class="bg-light">
  <div class="container align-items-center min-vh-100">
    <div class="row justify-content-center">
      <div class="col-12 col-md-6 col-lg-5">
        <div class="card shadow-sm p-4 py-4" style="border: none; border-radius: inherit;">
          <div class="text-center mb-3">
            <img src="https://acexpress.com.mx/images/asesorcontable2020-256.png" style="max-width: 190px" alt="Asesor Contable"/>
          </div>
          <div class="text-center text-muted mb-2 fw-medium">
            <small>Inicia sesión con tu cuenta de</small>
          </div>
          <form method="post" class="d-flex gap-3 justify-content-center align-items-center">
            <button mat-stroked-button class="w-100">
              <img src="assets/images/google.png" width="60" height="100" alt="Google" style="object-fit: contain;"/>
            </button>
            <button mat-stroked-button class="w-100">
              <img src="assets/images/microsoft.png" width="80" height="100" alt="Microsoft" style="object-fit: contain;"/>
            </button>
          </form>
          <div class="my-3 text-center text-muted fw-medium">
            <small>O usa tu cuenta de Asesor Contable</small>
          </div>
          <form (ngSubmit)="iniciarSesion()">
            <div class="mb-3 text-start">
              <label class="form-label mb-0">Usuario</label>
              <input type="email" name="email" autocomplete="email" [formControl]="emailControl" placeholder="Correo electrónico" class="form-control" [ngClass]="{'border border-danger form-control-danger': emailControl.hasError('emailError')}">
            </div>
            <div class="mb-3 text-start">
              <label class="form-label mb-0">Contraseña</label>
              <div class="position-relative">
                <input [type]="mostrarPassword ? 'text' : 'password'" name="password" autocomplete="current-password" [formControl]="passwordControl" placeholder="Contraseña" class="form-control" [ngClass]="{'border border-danger form-control-danger': passwordControl.hasError('passwordError')}" (keyup.enter)="iniciarSesion()">
                <mat-icon [fontIcon]="mostrarPassword ? 'visibility' : 'visibility_off'" class="position-absolute end-0 me-2" style="cursor: pointer;" (click)="mostrarPassword = !mostrarPassword"></mat-icon>
              </div>
              <div class="text-end" style="cursor: pointer;">
                <a class="text-decoration-none text-primary fw-medium"><small>¿Olvidaste tu contraseña?</small></a>
              </div>
            </div>
            <div class="text-danger my-3 fw-medium h6" *ngIf="mensajeError">{{ mensajeError }}</div>
            <div class="text-danger my-3 fw-medium h6" *ngIf="bloqMayusActivado"><small>El Bloq Mayús está activado</small></div>
            <button type="submit" mat-stroked-button class="w-100 fw-medium text-white" style="background-color: navy;">Iniciar Sesión</button>
          </form>
          <div class="text-center mt-3" style="cursor: pointer;">
            <a class="text-primary text-decoration-none fw-medium" (click)="crearCuenta()">¿Eres nuevo usuario? Regístrate aquí</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
